import { render, staticRenderFns } from "./addressList.vue?vue&type=template&id=51c12e40&scoped=true"
import script from "./addressList.vue?vue&type=script&lang=js"
export * from "./addressList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c12e40",
  null
  
)

export default component.exports